import { Injectable, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EventGuest } from '../../../shared/models/events/guests/event-guest.model';
import { BaseService } from '../../../shared/services/base.service';
import { _ } from '@ngx-translate/core';
import { guestFillDetailsPipe } from '../pipes/guest-fill-details-pipe';
@Injectable({
    providedIn: 'root'
})
export class EventGuestsService extends BaseService<EventGuest> {
    accesses$: Subject<EventGuest[]> = new Subject<EventGuest[]>();
    private _accesses: EventGuest[] = [];
    
    getAll(eventId: number): Observable<EventGuest[]> {
        return this.http.get<EventGuest[]>(`/api/events/${eventId}/guests`);
    }

    syncGuestDetails(eventId: number, guestId: number): Observable<void> {
        return this.http.post<void>(`/api/events/${eventId}/guests/${guestId}/sync-details`, {});
    }

    syncGuestsDetails(eventId: number, guestIds: number[]): Observable<void> {
        return this.http.post<void>(`/api/events/${eventId}/guests/sync-details`, guestIds);
    }

    getAccesses(eventId: number): void {
        this.http.get<EventGuest[]>(`/api/events/${eventId}/guests/accesses`).pipe(guestFillDetailsPipe())
            .subscribe(guests => {
                this._accesses = guests.map(g => {
                    return this.fillGuestAccessStatus(g);
                });
                this.accesses$.next(this._accesses);
            });
    }

    checkIn(guest: EventGuest): void {
        this.http.post<EventGuest>(`/api/events/${guest.event_id}/guests/${guest.id}/checkin`, {})
            .subscribe({
                next: (data) => {
                    this.replaceGuest(data);
                    this.messageService.add({severity: 'success', summary: _('general.success'), detail: 'Guest checked in successfully'});
                },
                error: (error) => this.messageService.add({severity: 'error', summary: _('general.error'), detail: error.error.message})
            });
    }

    deleteCheckIn(guest: EventGuest): void {
        this.http.delete<EventGuest>(`/api/events/${guest.event_id}/guests/${guest.id}/checkin`)
            .subscribe({
                next: (data) => {
                    this.replaceGuest(data);
                    this.messageService.add({severity: 'success', summary: _('general.success'), detail: 'Guest checkin removed successfully'});
                },
                error: (error) => this.messageService.add({severity: 'error', summary: _('general.error'), detail: error.error.message})
            });
    }

    private fillGuestAccessStatus(guest: EventGuest): EventGuest {
        if(guest.confirmation_status !== 'confirmed') {
            if(guest.check_in_date != null) {
                guest.access_status = 2;
            } else {
                guest.access_status = -1;
            }
        } else {
            guest.access_status = guest.check_in_date != null ? 1 : 0;
        }
        return guest;
    }

    private replaceGuest(data: EventGuest): void {
        const index = this._accesses.findIndex(g => g.id === data.id);
        if (index !== -1) {
            let guest = this._accesses[index];
            guest.check_in_date = data.check_in_date;
            this._accesses[index] = this.fillGuestAccessStatus(guest);
            this.accesses$.next(this._accesses);
        }
    }


    changeStatusByCodeSend(eventId: number, guestsGUIDs: string[], code: string): Observable<void> {
        let url = "ChangeStatus";
        if (code == "GUEST_PARKING") url = "ChangeStatusParking";
        if (code == "GUEST_ACCREDITATION") url = "ChangeStatusAccreditation";
        return this.http.post<void>(`/api/events/${eventId}/guests/status/document/${code}/print`, guestsGUIDs);
    }
}
